import { Box, Flex, Fade } from "@chakra-ui/react";
import PageLoader from '../../global/components/helper-components/components/PageLoader';
import ThinkingLogo from '../../global/components/helper-components/components/ThinkingLogo';
import LaunchdeckButton from '../../global/components/helper-components/components/LaunchdeckButton';
import LaunchdeckModal from "../../global/components/helper-components/components/LaunchdeckModal";


export default function DsrGenericLoadingModal({ modalText, triggerStateChange, handleOkOption }) {

  const renderModalContent = () => {
    return (
      <Flex direction='column' justify='center' align='center' w='100%'>
        <Box px='3%' w='100%'>
          {triggerStateChange ? <ThinkingLogo /> : <PageLoader />}
          <Box w="100%" mb="2em" align="center" color='brandDark.500' textAlign='center'
            whiteSpace='break-spaces'
            fontSize='0.875em'>
            <Fade in={true} key={modalText}>
              {modalText || "Working on it"}
            </Fade>
          </Box>
        </Box>
      </Flex>
    )
  }

  return (
    <LaunchdeckModal
      title={'Working on it'}
      showModal={true}
      maxW='35em'
      noCancelOption={true}
    >
      {renderModalContent()}
      {(handleOkOption && triggerStateChange) && <>
        <Flex alignItems='center' justify='center' mb='1.5em'>
          <LaunchdeckButton bg='brand.500' color='white' fontSize='0.875em' onClick={() => handleOkOption()} label='Notify me when ready' />
        </Flex>
      </>
      }
    </LaunchdeckModal>
  )
}
